import { useContext } from "react";
import icon_plus from "../assets/icons/icon_plus.svg";
import { TodosContext } from "../pages/ItemDetail";

const AddButon = (props) => {
  const { handleModalToggle } = useContext(TodosContext);
  const onClick = () => {
    handleModalToggle();
  };
  return (
    <button
      onClick={() => onClick()}
      data-cy="todo-add-button"
      className="flex flex-row gap-2 justify-center items-center w-[100px] h-[37px] bg-primary text-[12px] text-white text-sans rounded-[45px] md:w-[159px] md:h-[54px] md:text-lg"
    >
      <span
        className="h-3 w-3 bg-cover md:h-3.5 md:w-3.5"
        style={{ backgroundImage: `url(${icon_plus})` }}
      ></span>{" "}
      Tambah
    </button>
  );
};
export default AddButon;
